// Recovered compiled webpack factory 82025. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r() {
    let e = Object.create(null);
    return {
      on(t, r) {
        (e[t] || (e[t] = [])).push(r);
      },
      off(t, r) {
        e[t] && e[t].splice(e[t].indexOf(r) >>> 0, 1);
      },
      emit(t) {
        for (var r = arguments.length, n = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          n[a - 1] = arguments[a];
        (e[t] || []).slice().map((e) => {
          e(...n);
        });
      },
    };
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
